import { render, staticRenderFns } from "./LeadTouch.vue?vue&type=template&id=fac99488&scoped=true&"
import script from "./LeadTouch.vue?vue&type=script&lang=js&"
export * from "./LeadTouch.vue?vue&type=script&lang=js&"
import style0 from "./LeadTouch.vue?vue&type=style&index=0&id=fac99488&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fac99488",
  null
  
)

export default component.exports